// const API_URL = "https://portalapi.egansgroup.com.au/api/"; //Live API
const API_URL = "https://testportalapi.egansgroup.com.au/api/"; //Test API
//  const API_URL="http://10.0.12.15:8085/api/"
const AvailablePlantInterval=100;

export { API_URL , AvailablePlantInterval};
